import { Tooltip } from 'antd';
import React from 'react';
import styles from './InvoiceReviewer.module.less';
export var InvoiceInfoCheck = function (props) {
    var title = props.title, _a = props.tooltip, tooltip = _a === void 0 ? '' : _a, _b = props.className, className = _b === void 0 ? '' : _b, _c = props.icon, icon = _c === void 0 ? '' : _c, _d = props.warningTitle, warningTitle = _d === void 0 ? '' : _d, _e = props.warningText, warningText = _e === void 0 ? '' : _e;
    return (React.createElement("div", { className: styles['invoice-check-wrapper'] + " " + className },
        React.createElement(Tooltip, { placement: "top", title: tooltip, overlayStyle: { zIndex: 10000 } },
            React.createElement("div", { className: 'invoice-check-value' },
                React.createElement("span", null, title),
                icon && React.createElement("img", { className: styles.icon, src: icon }))),
        warningTitle && (React.createElement("div", { className: styles.warning },
            React.createElement("span", { className: styles['warning-title'] }, warningTitle),
            React.createElement("span", null, warningText)))));
};
